import { render, staticRenderFns } from "./BlockForm.vue?vue&type=template&id=f5b4006a&"
import script from "./BlockForm.vue?vue&type=script&lang=js&"
export * from "./BlockForm.vue?vue&type=script&lang=js&"
import style0 from "./BlockForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports